<wiz-hgroup width="100%" height="100%">
  <wiz-vgroup #vgDetailZone width="200px" style="overflow: auto">
    <ng-container #containerFilter></ng-container>
    <ng-container #containerFields></ng-container>
  </wiz-vgroup>
  <full-calendar #fullcalendar *ngIf="readyToGo && !tooMany"
  style="max-width: unset !important;"
  schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
  [options]="calendarOptions"
  ></full-calendar>
  <wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center" *ngIf="tooMany">
    <wiz-label [wizLabel]="tooManyLabel"></wiz-label>
  </wiz-hgroup>
</wiz-hgroup>
